export default __webpack_public_path__ + "static/media/212.55b60e66.jpg";